import type { ClassroomProcessing } from '../features/classroom/classroom-processing';
import { createContext } from 'react';
import type { SyncEngine, SyncEngineSnapshot } from './sync-engine';

export interface SyncContextValue {
  engine: SyncEngine;
  processing?: ClassroomProcessing;
  snapshot: SyncEngineSnapshot;
}

// 上下文身份独立于热更新的 Provider/Hook 模块，避免懒加载页面持有另一份 Context。
export const SyncContext = createContext<SyncContextValue | null>(null);
